import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Container } from "@material-ui/core";
import ProductCard from "components/product//ProductCard";
import { BaseUrl, endpoints } from "../utils/factory";
import axios from "axios";

const ProductList = () => {
  const [invoicelist, setInvoicelList] = useState([]);
  const clientName = localStorage.getItem("trans-userName");
  const cmp_id = localStorage.getItem("trans-cmp_id");

  // const loadNoteData = async () => {
  //   try {
  //     axios
  //       .post(`${BaseUrl}trans_loaditems`, {
  //         userid: clientid,
  //         qtype: '6',
  //         searchtext: '',
  //         fdate: '',
  //         tdate: '',
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
  //         }
  //       })
  //       .then((response) => {
  //         if (response.data.d.length > 0) {
  //           // eslint-disable-next-line no-eval
  //           const userdata = eval(response.data.d);
  //           setInvoicelList(userdata);
  //         } else setInvoicelList([]);
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const loadNoteData = async () => {
    console.log("******** anmol response11");

    const clientid = localStorage.getItem("trans-userId");
    const cmp_id = localStorage.getItem("trans-cmp_id");

    console.log("******** anmol response22", clientid);


    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.getNoificationCount}`,
        {
          userid: clientid,
          qtype: "6",
          searchtext: "",
          fdate: "",
          tdate: "",
          cmp_id: cmp_id,
        }
      );

      console.log("******** anmol response33", response.data);

      const recordset = Array.isArray(response?.data?.recordset)
        ? response.data.recordset
        : Array.isArray(response?.data?.recordsets?.[0])
        ? response.data.recordsets[0]
        : [];

      if (recordset.length > 0) {
        setInvoicelList(recordset);
      } else {
        setInvoicelList([]);
      }
    } catch (error) {
      console.error("API error", error);
    }
  };

  useEffect(() => {
    console.log("******** anmol response00");
    loadNoteData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Notification List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <ProductCard product={invoicelist} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ProductList;
